<template>
  <el-select
    v-model="cafeteriaModel"
    @change="cafeteriaValChanged"
    autocomplete="new-password"
    :placeholder="$t('COMMON.CAFETERIA')"
    :filterable="filterable"
    :multiple="multiple"
    :disabled="disabled"
    remote
    :remote-method="getCafeterias"
    :loading="loading"
  >
    <el-option v-if="showAll" :value="null" :label="$t('COMMON.ALL_CAFETERIAS')">
    </el-option>
    <el-option v-if="allowNone" :value="null" :label="$t('COMMON.NONE')"> </el-option>
    <el-option
      v-for="cafeteria in cafeterias"
      :key="cafeteria.id"
      :value="cafeteria.id"
      :label="`${cafeteria.name}`"
    >
    </el-option>
  </el-select>
</template>

<script>
import { Option, Select } from "element-ui";

export default {
  name: "cafeteria-selector",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
      description: "Disable the input",
    },
    showAll: {
      type: Boolean,
      default: true,
      description: "Show the option all",
    },
    allowNone: {
      type: Boolean,
      default: false,
      description: "Show the option none",
    },
    filterable: {
      type: Boolean,
      default: true,
      description: "Can filter",
    },
    multiple: {
      type: Boolean,
      default: false,
      description: "Can filter",
    },
    cafeteria: {
      type: String,
      default: null,
      description: "Cafeteria id",
    },
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterEstablishment: {
      type: String,
      default: null,
      description: "Establishment id",
    },
    filterServiceCenter: {
      type: String,
      default: null,
      description: "ServiceCenter id",
    },
    filterOperationType: {
      type: String,
      default: null,
      description: "Operation type",
    },
    filterOrderType: {
      type: String,
      default: null,
      description: "Order type filter",
    },
  },

  data() {
    return {
      cafeteriaModel: this.cafeteria,
      cafeterias: {},
      loading: true,
    };
  },

  setup() {},

  created() {
    this.getCafeterias(null, this.cafeteria);
  },

  methods: {
    async getCafeterias(query = null, id = null) {
      try {
        this.loading = true;
        let params = {
          include: "warehouse",
          sort: "name",
          filter: {
            ...(query ? { search: encodeURIComponent(query) } : {}),
             ...(id ? { id: id } : {}),
          },
          page: {
            number: 1,
            size: 10,
          },
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.filterOrganization,
            },
          };
        }

        if (this.filterEstablishment) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              establishment: this.filterEstablishment,
            },
          };
        }

        if (this.filterServiceCenter) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              serviceCenter: this.filterServiceCenter,
            },
          };
        }

        if (this.filterOperationType) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              operation_type: this.filterOperationType,
            },
          };
        }

        if (this.filterOrderType) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              order_type: this.filterOrderType,
            },
          };
        }

        await this.$store.dispatch("cafeterias/list", params);
        const cafeteriasArr = await this.$store.getters["cafeterias/list"];
        this.cafeterias = {};
        cafeteriasArr.forEach((cafeteria) => {
          this.cafeterias[cafeteria.id] = cafeteria;
        });
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    cafeteriaValChanged(cafeteria) {
      const cafeteriaSelected = Object.values(this.cafeterias).find(
        (item) => item.id === cafeteria
      );
      this.$emit("cafeteriaChanged", cafeteria, cafeteriaSelected);
    },
  },

  watch: {
    cafeteria(cafeteria) {
      if (cafeteria) {
        if (cafeteria !== this.cafeteriaModel) {
          this.cafeteriaModel = cafeteria;
          this.getCafeterias(null, cafeteria);
        }
      } else {
        this.cafeteriaModel = null;
      }
    },
    filterOrganization(filterOrganization) {
      this.getCafeterias();
    },
    filterServiceCenter(filterServiceCenter) {
      this.getCafeterias();
    },
    filterEstablishment(filterEstablishment) {
      this.getCafeterias();
    },
    filterOperationType(filterEstablishment) {
      this.getCafeterias();
    },
  },
};
</script>
